import React, { Component } from 'react';
import moment from 'moment';
import Slider from 'react-slick';

import DesignService from '../../services/DesignService/DesignService';
import Slide from '../../components/Slide/Slide';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';

import cfg from '../../config/config.default';
import './App.css';

export default class App extends Component {
  /**
   * Constructor
   *
   * @param {any} props
   */
  constructor(props) {
    super(props);

    this.sliderMaxDesigns = 10;
    this.state = {
      designs: [],
      loading: true,
      newestUuidDate: '',
    };

    setInterval(() => this.getLatestSoldDesigns(), cfg.refreshDelay);
  }

  /**
   * Load latest sold designs
   */
  async getLatestSoldDesigns(newerThan = null) {
    if (!newerThan) newerThan = this.state.newestUuidDate;

    const { designs } = this.state;
    const latest = await DesignService.getSoldUuids(newerThan); // Sorted by `created_at DESC`

    // Remove blacklisted UUIDs and only keep the oldest 10 UUIDs
    const latestUuids = latest
    .map((design) => design.uuid)
    .filter((uuid) => !cfg.blacklist.uuids.includes(uuid))
    .slice(-this.sliderMaxDesigns);

    // Only continue if new designs are available
    if (!latestUuids.length) return;

    const newestUuidDate = moment(latest.find(d => d.uuid === latestUuids[0])
      .last_created_at, 'YYYY-MM-DD hh:mm:ss').format('YYYY-MM-DD hh:mm:ss');

    // Fetch UUIDs details
    let latestDesigns = await DesignService.getDesigns(latestUuids);

    // DesignService.getDesigns() sorts designs by UUID creation and not sold date
    let sortedDesigns = [];
    latestUuids.forEach((uuid) => sortedDesigns.push(latestDesigns.find((design) => design.uuid === uuid)));

    // Prepend latest designs to current designs and keep newest 10 ones
    sortedDesigns = sortedDesigns
      .filter(design => Boolean(design))
      .concat(designs).slice(0, this.sliderMaxDesigns);

    this.setState({
      designs: sortedDesigns,
      loading: false,
      newestUuidDate,
    });
  }

  /**
   * On mount
   */
  componentDidMount() {
    // Start by fetching sold designs from the past day
    const someDaysAgo = moment().subtract(1, 'days').format('YYYY-MM-DD');
    this.getLatestSoldDesigns(someDaysAgo);
  }

  /**
   * @return {React.JSX}
   */
  renderSpinner() {
    return (<LoadingSpinner />);
  }

  /**
   * @return {React.JSX}
   */
  renderSlider() {
    const { designs } = this.state;
    const sliderOpts = {
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 12000,
      cssEase: 'linear',
      dots: true,
      fade: true,
      infinite: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      slidesToScroll: 1,
      slidesToShow: 1,
      speed: 500
    };

    return (
      <Slider { ...sliderOpts }>
        { designs
            .filter(design => Boolean(design))
            .map((design, key) => <Slide key={ key } design={ design } />)
        }
      </Slider>
    );
  }

  /**
   * @return {React.JSX}
   */
  render() {
    const { loading } = this.state;

    return (
      <div className="App">
        { loading ? this.renderSpinner() : this.renderSlider() }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/App/App.js